import { useInfiniteQuery } from "@tanstack/react-query";
import { getTenantAudit } from "../api";

export function useTenantAudit(tenantId: string, enabled = true) {
  return useInfiniteQuery({
    queryKey: ["tenant-audit", tenantId],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await getTenantAudit(tenantId, pageParam as number, 20);
      return {
        data: response.data,
        pagination: response.pagination,
        nextPage:
          pageParam < response.pagination.totalPages
            ? (pageParam as number) + 1
            : undefined,
      };
    },
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    enabled: enabled && !!tenantId,
  });
}
